import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PopupApi } from 'api';
import type { Popup } from 'api/methods/PopupApi';

/**
 * [Popup] Query key 생성
 * --
 */
export const popupQueryKeys = createQueryKeys('popup', {
  getPopup: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getPopups: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Popup] 팝업 전체 조회
 * --
 */
export const useGetPopups = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: popupQueryKeys.getPopups(params).queryKey,
    queryFn: () => PopupApi.getPopups(params),
    ...options,
  });
  return data;
};

/**
 * [Popup] 팝업 상세 조회
 * --
 */
export const useGetPopup = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: popupQueryKeys.getPopup(idx, params).queryKey,
    queryFn: () => PopupApi.getPopup(idx, params),
  });

  return data;
};

/**
 * [Popup] 팝업 생성
 * --
 */
export const useCreatePopup = (body: Popup) => {
  const { mutateAsync: createPopup, ...result } = useMutation({
    mutationFn: (variables: Popup) => PopupApi.createPopup(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createPopup, ...result };
};

/**
 * [Popup] 팝업 수정
 * --
 */
export const useUpdatePopup = (body: Popup) => {
  const { mutateAsync: updatePopup, ...result } = useMutation({
    mutationFn: (variables: Popup) => PopupApi.updatePopup(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updatePopup, ...result };
};

/**
 * [Popup] 팝업 삭제
 * --
 */
export const useDeletePopup = (idx: number) => {
  const { mutateAsync: deletePopup, ...result } = useMutation({
    mutationFn: (variables: number) => PopupApi.deletePopup(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deletePopup, ...result };
};
